$traceurRuntime.ModuleStore.getAnonymousModule(function() {
  "use strict";
  angular.module('app.test').service('TestScore', function($q, $state, $rootScope) {
    var initial = {};
    var initial = JSON.stringify(initial);
    var state = JSON.parse(localStorage.state || '{}');
    var set = (function(data) {
      angular.merge(state, data);
      localStorage.state = JSON.stringify(state);
    });
    return {
      set: set,
      addScore: (function(question, score) {
        state[question] = score;
        localStorage.state = JSON.stringify(state);
      }),
      reset: (function() {
        state = JSON.parse(initial);
        localStorage.state = JSON.stringify(state);
      }),
      get: (function() {
        return angular.extend({}, state);
      }),
      results: (function() {
        var result = {
          blauw: 0,
          groen: 0
        };
        var scores = state;
        _.each(scores, function(value, key) {
          var team = key;
          _.each(value, function(value, key) {
            value === true ? result[team]++ : '';
          });
        });
        return result;
      })
    };
  });
  return {};
});

